import { combinePaths, getBaseFileName, getDirectoryPath } from './sys';

export const dirname = getDirectoryPath;
export const basename = getBaseFileName;
export const join = combinePaths;
